import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { writeAdditions } from 'app/store/project/addition-fields/addition-fields.actions';
import { AdditionalField } from 'app/store/project/addition-fields/addition-fields.reducer';
import { selectedAdditions } from 'app/store/project/addition-fields/addition-fields.selectors';
import { ownedError } from 'core/utils/owned-error';
import { selectFirst } from 'core/utils/rx-common';

@Component({
  selector: 'app-additional-fields-search',
  templateUrl: './additional-fields-search.component.html',
  styleUrls: ['./additional-fields-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdditionalFieldsSearchComponent implements OnInit {
  private _additionalFields = new Array<AdditionalField>();
  private _extendedMode = false;
  private _selectedAdditions = new Array<AdditionalField>();

  @Input()
  set additionalFields(f: AdditionalField[]) {
    this._additionalFields = f;
  }

  get additionalFields(): AdditionalField[] {
    return this._additionalFields;
  }

  get extendedMode(): boolean {
    return this._extendedMode;
  }

  @Input()
  set extendedMode(value: boolean) {
    this._extendedMode = value;
  }

  get form(): UntypedFormGroup {
    const group = this.controlContainer.control;

    if (!(group instanceof UntypedFormGroup)) {
      throw ownedError(new TypeError('Invalid ControlContainer given'));
    }

    return group;
  }

  get selectedAdditions(): AdditionalField[] {
    return this._selectedAdditions;
  }

  set selectedAdditions(value: AdditionalField[]) {
    this._selectedAdditions = value;
  }

  constructor(
    private controlContainer: ControlContainer,
    private store$: Store,
  ) { }

  ngOnInit(): void {
    this.store$.pipe(selectFirst(selectedAdditions))
      .subscribe(fields => this.selectedAdditions = fields);
  }

  writeInStorage(fields: AdditionalField[]): void {
    this.store$.dispatch(writeAdditions({ fields }));
  }

  compareByName(f1: AdditionalField, f2: AdditionalField): boolean {
    return f1 && f2 && f1.name === f2.name;
  }
}
